import gsap from 'gsap';


export default class Howto{

    constructor() {
        this._init();
    }

    _init(){
        this.$howto = document.querySelector('.js-howto');
        this.slideList = [...document.querySelectorAll('.howto__slide')];
        this.nowIdx = 0;
        
        // modal ui
        document.querySelector('.top__btnlist__item.-howto').addEventListener('click', ()=>{
            this.$howto.classList.add('-active');
        });

        document.querySelector('.js-howto-close').addEventListener('click', ()=>{
            this.$howto.classList.remove('-active');
        });


        // slider ui
        this.$btnPrev = document.querySelector('.howto__nav.-prev');
        this.$btnNext = document.querySelector('.howto__nav.-next');

        this.$btnPrev.addEventListener('click', ()=>{
            this._changeSlide(0);
        });

        this.$btnNext.addEventListener('click', ()=>{
            this._changeSlide(1);
        });

        this._changeSlide(0);
    }
    

    _changeSlide(idx){
        this.slideList[this.nowIdx].classList.remove('-active');
        this.slideList[idx].classList.add('-active');

        if(idx == 0){
            this.$btnPrev.classList.add('-disable');
            this.$btnNext.classList.remove('-disable');
        }
        else{
            this.$btnPrev.classList.remove('-disable');
            this.$btnNext.classList.add('-disable');
        }

        this.nowIdx = idx;
    }
}
